import { observable, action, configure, makeObservable } from 'mobx';
import { IEdetector } from '@utils/browserUTLs';
// import { getLocalStorageItem } from '@utils/getLocalStorageItem';

configure({
  enforceActions: 'observed',
  useProxies: IEdetector() ? 'never' : 'always'
});

// const defaultStoreId = +getLocalStorageItem<string>('x-store-id') || 1;

class Store {
  xStoreId: number | null = null;

  storeChangeCount: number = 0;

  private lastKnownStoreId: number | null = null;

  isLoading: boolean = true;

  constructor() {
    makeObservable(this, {
      xStoreId: observable,
      storeChangeCount: observable,
      isLoading: observable,
      setXStoreId: action
    });
  }

  resetStore = (): void => {
    this.xStoreId = null;
  };

  setIsLoading = (value: boolean): void => {
    this.isLoading = value;
  };

  setXStoreId = (xStoreId: number): void => {
    if (xStoreId !== this.xStoreId) {
      if (
        this.lastKnownStoreId !== null &&
        xStoreId !== this.lastKnownStoreId
      ) {
        this.storeChangeCount += 1;
      }
      this.lastKnownStoreId = xStoreId;
      this.xStoreId = xStoreId;
      // this.xStoreId = xStoreId || defaultStoreId;
      // localStorage.setItem('x-store-id', `${xStoreId || defaultStoreId}`);
    }
    this.setIsLoading(false);
  };
}

const xStore = new Store();
export type XStoreT = typeof xStore;
export default xStore;
